import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ActivityIndicator } from '@lyearn-team/frontend-components'; // activity indicator
import $j from 'jquery';
import { downloadHtmlFileContent as downloadHtml } from '../../../helper/downloadHtmlContent';
// import LoadingReact from '../../../components/LoadingReact';

const myOptions = {
  nativeControlsForTouch: false,
  controls: true,
  // autoplay: true,
  width: 'auto',
  height: 'auto',
  logo: { enabled: false },
  hotKeys: {
    seekStep: 10,
    enableJogStyle: false,
    volumeStep: 0.2
  } /* ,
  plugins: {
    playbackrate: {}
  } */
};

export default class HTMLCard extends Component {
  static propTypes = {
    cardId: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    // this.parseHtmlContent();
  }

  state = {};

  componentDidMount() {
    const cardDataUrl = this.props.card.url;
    window.eval(
      `
        function imageLoadedNew(){
          imageLoaded();
          var imgContainer = document.querySelector('.imgContainer');
          imgContainer && imgContainer.setAttribute('style','');
        }
      `
    );

    if (this.props.card.data) {
      this.parseHtmlContent(this.props.card.data);
    } else if (cardDataUrl && cardDataUrl !== '') {
      this.getHtmlContent(this.props);
    }
    this.setState({}, () => {
      this.setLiMargin();
      this.convertVideoToAzure();
      this.applyIntense($j('.HtmlContentWrapper img').not('.azuremediaplayer img'));
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      if (nextProps.card.data) {
        this.parseHtmlContent(nextProps.card.data);
      } else if (nextProps.card.url && nextProps.card.url !== '') {
        this.getHtmlContent(nextProps);
      }
    }
  }

  componentDidUpdate(prevProps) {
    this.setLiMargin();
    if (this.props.cardId !== prevProps.cardId) {
      this.convertVideoToAzure();
    }
    this.applyIntense($j('.HtmlContentWrapper img').not('.azuremediaplayer img'));
  }

  convertVideoToAzure = () => {
    const self = this;
    $j('.HtmlContentWrapper video').each(function () {
      $j(this).addClass('azuremediaplayer amp-default-skin amp-big-play-centered');
      const videoUrl = $j(this).attr('src');
      const videoPlayer = window.amp(this, myOptions, this.videoPlayerLoaded);
      self.setSrc(videoPlayer, videoUrl);
      // $j(this).attr('src', '');
    });
  };

  setSrc = (videoPlayerRef, newSrc) => {
    // console.log(newSrc, shouldAttachEvents);
    videoPlayerRef && videoPlayerRef.pause();
    if (newSrc && newSrc.includes('.mp4')) {
      videoPlayerRef.src({ type: 'video/mp4', src: newSrc });
    } else if (newSrc && newSrc.includes('/manifest')) {
      videoPlayerRef.src({ type: 'application/vnd.ms-sstr+xml', src: newSrc });
    }
    // newThumbImage && videoPlayerRef.poster(newThumbImage);
    // videoPlayerRef.autoplay(true);
    // videoPlayerRef.currentTime(0);
  };

  setLiMargin = () => {
    // console.log($j('.HtmlContentWrapper li').length);
    $j('.HtmlContentWrapper li')
      .not('.marginChanged')
      .each(function () {
        const liElem = $j(this);
        let marginLeft = parseInt($j(this).css('margin-left'), 10) - 30;
        marginLeft = marginLeft > -1 ? marginLeft : 0;
        liElem.addClass('marginChanged');
        liElem.css('margin-left', marginLeft);
      });
  };

  getHtmlContent = (props) => {
    const cardDataUrl = props.card.url;
    if (!window.htmlCardsContent[props.cardId]) {
      this.state.loadingContent = true;
      downloadHtml(cardDataUrl).then(
        ({ status, htmlContent }) => {
          this.parseHtmlContent(htmlContent);
          window.htmlCardsContent[props.cardId] = this.htmlContent;
          this.setState({ loadingContent: false }, () => {
            this.setLiMargin();
            this.convertVideoToAzure();
          });
        },
        () => {
          this.setState({ loadingContent: false });
        }
      );
    } else {
      this.htmlContent = window.htmlCardsContent[props.cardId];
    }
  };

  getHTMLObject() {
    return {
      __html: this.htmlContent
    };
  }

  applyIntense = (images) => {
    if (images.length > 0 && images.data('intenseInit') !== true) {
      images.data('intenseInit', true);
      window.Intense && window.Intense(images);
    }
  };

  parseHtmlContent(htmlData) {
    this.htmlContent = htmlData;
    // This code manually removes the script tag from html data
    // and puts it into global window context using window.eval.
    // The aspectRatio is taken from the string of html and
    // style tag of div is replaced to have appropriate min-width
    // and min-height.
    // const scriptContentArray = /<script type=text\/javascript>(.*?)<\/script>/gi.exec(this.htmlContent);
    const scriptRegEx = /<script type=text\/javascript>(.*?)<\/script>/gi;
    const scriptContentToReplaceFromHTML = [];
    let scriptContentArray = scriptRegEx.exec(this.htmlContent);
    // console.log('scriptContentArray 11:: ', scriptContentArray, scriptRegEx.lastIndex);

    while (scriptContentArray !== null) {
      // var msg = 'Found ' + myArray[0] + '. ';
      // console.log('scriptContentArray:: ', scriptContentArray, scriptRegEx.lastIndex);
      // scriptToBeExec += tempStore[1];

      if (scriptContentArray && scriptContentArray.length > 0) {
        const scriptContent = scriptContentArray[0];
        // this.htmlContent = this.htmlContent.replace(scriptContent, '');
        scriptContentToReplaceFromHTML.push(scriptContent);

        window.eval(scriptContentArray[1]);
        // console.log('executed:: ', scriptContentArray[1]);

        const aspectRatioArray = /var aspectRatio=(.*?);/gi.exec(scriptContent);
        // const aspectRatioArray = 0.8278867102;
        const aspectRatio = aspectRatioArray && aspectRatioArray.length === 2 ? parseFloat(aspectRatioArray[1]) : 0;
        // console.log($j('.HtmlContentWrapper').width());
        let imageWidth = $j('.HtmlContentWrapper').width() || document.body.offsetWidth;
        let imageHeight = imageWidth * aspectRatio;
        imageWidth = 'min-width:' + imageWidth + 'px;';
        imageHeight = 'min-height:' + imageHeight + 'px;';
        const styleTag = 'style=' + imageWidth + imageHeight;

        this.htmlContent = this.htmlContent.replace(
          '<div class="loading imgContainer">',
          '<div class="loading imgContainer" ' + styleTag + '>'
        );
        this.htmlContent = this.htmlContent
          .replace('.loading', '.loadingImageContainer')
          .replace('class="loading', 'class="loadingImageContainer');
        this.htmlContent = this.htmlContent.replace('=imageLoaded()', '=imageLoadedNew()');
      }
      scriptContentArray = scriptRegEx.exec(this.htmlContent);
      // console.log('scriptContentArray 22:: ', scriptContentArray, scriptRegEx.lastIndex);
    }
    if (scriptContentToReplaceFromHTML.length > 0) {
      scriptContentToReplaceFromHTML.map((scriptTag) => {
        this.htmlContent = this.htmlContent.replace(scriptTag, '');
      });
    }
    this.htmlContent = this.htmlContent.replace(/Roboto-Regular/g, 'ProximaNova');
  }

  render() {
    // console.log('HTML CARD');
    // this.parseHtmlContent();
    return (
      <div className="HtmlContentWrapper desktop-view" style={styles.container}>
        {this.state.loadingContent ? (
          <div style={styles.loaderWrapper}>
            <ActivityIndicator
              width={50}
              height={50}
              style={styles.loader}
              svgColor={styles.loaderColor}
            />
          </div>
        ) : (
          <div dangerouslySetInnerHTML={this.getHTMLObject()} />
        )}
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    maxWidth: '800px',
    height: '100%',
    // backgroundColor: '#fff',
    margin: '0 auto',
    // border: '1px solid #DBE2E8',
    // justifyContent: 'center',
    flexDirection: 'column',
    // minHeight: '50vh',
    padding: '0px',
    boxSizing: 'border-box'
    // minHeight: 'calc(100vh - 200px)',
  },
  audioContainer: {
    width: 'auto',
    alignSelf: 'center'
  },
  loaderWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '30px 0 0 0'
  },
  loader: {
    height: '50px',
    width: '50px'
  },
  loaderColor: '#0abff1'
};
